import { Option, Select } from "../select";
import { useState, useEffect } from "react";
export default function Dropdown({ value, onChange, params }) {
  const [_value, setValue] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value]);

  useEffect(() => {
    try {
      setOptions(params.options);
    } catch (err) {
      setOptions([]);
    }
  }, [params]);

  const handleSelect = (v) => {
    setValue(v);
    onChange(v);
  };
  return (
    <div>
      <Select onChange={handleSelect} value={_value}>
        {options.map((o) => {
          return (
            <Option key={o.value} value={o.value}>
              {o.text}
            </Option>
          );
        })}
      </Select>
    </div>
  );
}
